export const HOTEL_RESULT_URL_PARAMS_POSITION = {
  DESTINATION_TYPE: 2,
  DESTINATION_ID: 3,
  CHECK_IN: 4,
  CHECK_OUT: 5,
  CURRENCY: 6,
  ROOMS: 7
};

export const HOTEL_DETAIL_URL_PARAMS_POSITION = {
  HOTEL_NAME: 2,
  ARRIVAL: 3,
  DEPARTURE_DATE: 4,
  ARRIVAL_DATE: 5,
  ROOMS: 6,
  CURRENCY: 7
};

export function setHotelResultURL(url: string, detailUrl: string): string {
  const newDepartureDate = getParamByHotelDetailURL(detailUrl, HOTEL_DETAIL_URL_PARAMS_POSITION.DEPARTURE_DATE);
  const newArrivalDate = getParamByHotelDetailURL(detailUrl, HOTEL_DETAIL_URL_PARAMS_POSITION.ARRIVAL_DATE);
  const newGuestFormat = getParamByHotelDetailURL(detailUrl, HOTEL_DETAIL_URL_PARAMS_POSITION.ROOMS);
  const splitBaseUrl = url ? url.split('/') : null;
  if (splitBaseUrl && splitBaseUrl.length &&
    splitBaseUrl[HOTEL_RESULT_URL_PARAMS_POSITION.CHECK_IN] &&
    splitBaseUrl[HOTEL_RESULT_URL_PARAMS_POSITION.CHECK_OUT] &&
    splitBaseUrl[HOTEL_RESULT_URL_PARAMS_POSITION.ROOMS]
  ) {
    splitBaseUrl[HOTEL_RESULT_URL_PARAMS_POSITION.CHECK_IN] = newDepartureDate;
    splitBaseUrl[HOTEL_RESULT_URL_PARAMS_POSITION.CHECK_OUT] = newArrivalDate;
    splitBaseUrl[HOTEL_RESULT_URL_PARAMS_POSITION.ROOMS] = newGuestFormat;
    return splitBaseUrl.join('/');
  } else return '';
}

function getParamByHotelDetailURL(url: string, position: number): string {
  const splitBaseUrl = url ? url.split('/') : null;
  return splitBaseUrl && splitBaseUrl.length && splitBaseUrl[position] ? splitBaseUrl[position] : null;
}
